import "./src/styles/global.css";
import React from "react";
import { CookiesProvider } from "./src/context/CookiesContext";

export const wrapRootElement = ({ element }) => (
  <CookiesProvider>{element}</CookiesProvider>
);
